import type { EveMessage } from 'eve/vue'

/** Keep active progress after a follow-up without moving earlier assistant text. */
export function hasLaterSteeringMessage(
  messages: readonly EveMessage[],
  assistantIndex: number,
  activeTurnId?: string,
) {
  const assistant = messages[assistantIndex]
  const turnId = assistant?.role === 'assistant' ? assistant.metadata?.turnId : undefined
  if (!turnId)
    return false

  return messages.slice(assistantIndex + 1).some(message =>
    message.role === 'user'
    && (message.metadata?.turnId === turnId
      || (message.metadata?.optimistic && turnId === activeTurnId)),
  )
}
